<template>
  <div class="m-change-status">
    <b-modal
      :id="id"
      v-model="localActive"
      size="custom-size"
      centered
      hide-footer
      hide-header
      @show="onShowChangeStatusModal"
      @close="localActive = false"
    >
      <svg
        class="m-change-status-close"
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="localActive = false"
      >
        <path
          d="M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z"
          fill="#8E9CBB"
        />
        <path
          d="M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z"
          fill="#8E9CBB"
        />
      </svg>

      <div v-if="modalTitle" class="m-change-status-title">
        {{ modalTitle }}
      </div>

      <div class="m-change-status-fullname">{{ record.fullName.value }}</div>

      <c-input
        v-model="localEmployeeStatus"
        class="m-change-status-select-choice-status"
        :class="{
          'm-change-status-select-choice-status-required':
            localEmployeeStatus === null && localEmployeeStatusRequiredMessage !== '',
        }"
        label="Выберите статус"
        type="select"
        :items="localEmployeeStatusList"
        :searchable="true"
        :required="localEmployeeStatusRequiredMessage"
        :required-condition="localEmployeeStatus === null"
        placeholder="Выберите статус сотрудника"
      />

      <transition name="fade">
        <div>
          <c-input
            v-if="localEmployeeStatus !== null && localEmployeeStatus.fired === 1"
            v-model="localEmployeeBaseDismissal"
            class="m-change-status-select-choice-base"
            :class="{
              'm-change-status-select-choice-base-required':
                localEmployeeBaseDismissal === null && localEmployeeBaseDismissalRequiredMessage !== '',
            }"
            label="Основание для увольнения"
            type="select"
            :items="localEmployeeBaseDismissalList"
            :searchable="true"
            :required="localEmployeeBaseDismissalRequiredMessage"
            :required-condition="localEmployeeBaseDismissal === null"
            :with-special-value="true"
            placeholder="Выберите основание для увольнения"
          />

          <show-description :value="localEmployeeBaseDismissal && localEmployeeBaseDismissal.descriptionModel" />
        </div>
      </transition>

      <transition name="fade">
        <c-input
          v-if="localEmployeeBaseDismissal !== null && localEmployeeBaseDismissal.specialValue"
          v-model="localReasonForDismissal"
          class="m-change-status-input-cause"
          type="textarea"
          textarea-max-height="250"
          :input-text-condition="localEmployeeBaseDismissalRequiredMessage"
          placeholder="Введите причину"
        />
      </transition>

      <div class="m-change-status-buttons">
        <c-button color="white" label="Отменить" @click="closeModal" />
        <c-button color="primary" label="Применить" @click="changeWorkerStatus" />
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import moment from "moment";
import Button from "@/components/controls2/Button";
import Input from "@/components/controls2/Input";
import { FireReasonDescription } from "@/entities/models/fire-reason";
import { wordForm } from "@/utils/text/wordForm";
import ShowDescription from "@/components/show-description";

export default {
  name: "m-change-status",
  components: {
    "c-button": Button,
    "c-input": Input,
    ShowDescription,
  },
  props: ["active", "modalTitle", "modalText", "buttons", "input", "id", "record"],
  data() {
    return {
      localActive: false,
      localEmployeeStatus: null,
      localEmployeeStatusList: [],
      localEmployeeStatusRequiredMessage: "",
      localEmployeeBaseDismissal: null,
      localEmployeeBaseDismissalList: [],
      localEmployeeBaseDismissalRequiredMessage: "",
      localReasonForDismissal: "",
      isActiveLocalReasonForDismissalWatcher: false,
      localReasonForDismissalRequiredMessage: "",
    };
  },

  computed: {
    ...mapGetters("employees", ["getReferenceValues"]),
    ...mapGetters("referenceDismissalReasons", ["getReasonsCollection"]),

    dismissalReasonsDictionary() {
      return {};
    },
  },

  watch: {
    localActive(value) {
      if (!value) {
        this.$emit("close");
        this.localEmployeeStatus = null;
        this.localEmployeeBaseDismissal = null;
        this.localEmployeeStatusRequiredMessage = "";
      }
    },
    active(value) {
      this.localActive = value;
    },
    localReasonForDismissal(value) {
      if (this.isActiveLocalReasonForDismissalWatcher) {
        if (value === undefined || value === null || value.length === 0) {
          this.localEmployeeBaseDismissalRequiredMessage = "Обязательный параметр";
        } else {
          this.localEmployeeBaseDismissalRequiredMessage = "";
        }
      }
    },
  },

  created() {},

  methods: {
    closeModal() {
      this.localActive = false;
      setTimeout(() => {
        this.localEmployeeStatus = null;
        this.localEmployeeStatusRequiredMessage = "";
        this.localEmployeeBaseDismissal = null;
        this.localEmployeeBaseDismissalRequiredMessage = "";
        this.isActiveLocalReasonForDismissalWatcher = false;
      }, 300);
    },

    getValue(value) {
      this.valueFromInput = value;
    },

    onShowChangeStatusModal() {
      this.$store.dispatch("employees/getReferenceValues", "workerStatus").then((res) => {
        this.localEmployeeStatusList = res.data.map((status) => ({
          value: status.id,
          label: status.name,
          fired: status.fired,
        }));
        this.$store.dispatch("employees/getWorkerStatus", this.record.id).then((res) => {
          if (res.response.id !== null) {
            this.localEmployeeStatus = { value: res.response.id, label: res.response.name, fired: res.response.fired };
            if (this.localEmployeeStatus.fired === 1 && res.response.reason !== undefined) {
              this.localEmployeeBaseDismissal = { value: res.response.reason.id, label: res.response.reason.name };
            }
          }
          this.$store.dispatch("employees/getDismissReasons").then((res) => {
            this.localEmployeeBaseDismissalList = res.response.map((dismissReason) => {
              const { id: value, description: label } = dismissReason;
              const descriptionModel = FireReasonDescription(dismissReason);
              const { link, description, files } = descriptionModel;

              let subLabel = null;
              if (description) subLabel = description;
              else if (files.length) {
                subLabel = `${files.length} ${wordForm(files.length, ["файл", "файла", "файлов"])} ${
                  link && "и ссылка в описании"
                }`;
              } else if (link) {
                subLabel = "Ссылка в описании";
              }

              return {
                value,
                label,
                subLabel,
                descriptionModel,
              };
            });

            this.localEmployeeBaseDismissalList.unshift({
              value: -1,
              label: "Указать свою причину",
              specialValue: true,
            });
          });
        });
      });
    },

    changeWorkerStatus() {
      let isReadyChangeWorkerStatus = true;

      if (this.localEmployeeStatus === null) {
        this.localEmployeeStatusRequiredMessage = "Обязательный параметр";
        isReadyChangeWorkerStatus = false;
        return;
      }

      if (this.localEmployeeStatus.fired === 1 && this.localEmployeeBaseDismissal === null) {
        this.localEmployeeBaseDismissalRequiredMessage = "Обязательный параметр";
        isReadyChangeWorkerStatus = false;
        return;
      }

      if (
        this.localEmployeeStatus.fired === 1 &&
        this.localEmployeeBaseDismissal === null &&
        this.localReasonForDismissal.length === 0
      ) {
        this.localEmployeeBaseDismissalRequiredMessage = "Обязательный параметр";
        isReadyChangeWorkerStatus = false;
        return;
      }

      if (
        this.localEmployeeStatus.fired === 1 &&
        this.localEmployeeBaseDismissal.value === -1 &&
        this.localReasonForDismissal.trim().length === 0
      ) {
        this.isActiveLocalReasonForDismissalWatcher = true;
        this.localEmployeeBaseDismissalRequiredMessage = "Обязательный параметр";
        isReadyChangeWorkerStatus = false;
        return;
      }

      if (isReadyChangeWorkerStatus) {
        const params = {
          workerId: this.record.id,
          statusId: this.localEmployeeStatus.value,
          dismissId: this.localEmployeeBaseDismissal !== null ? this.localEmployeeBaseDismissal.value : undefined,
          desc:
            this.localEmployeeBaseDismissal && this.localEmployeeBaseDismissal.value === -1
              ? this.localReasonForDismissal.trim()
              : undefined,
        };
        this.$store.dispatch("employees/changeEmployeeStatus", params).then(() => {
          this.record.workerStatus.value = this.localEmployeeStatus.label;
          const statusChangeDate = moment().format("DD.MM.YYYY").toString();
          this.record.statusChangeDate.value = statusChangeDate;
          // Если статус "Уволен"
          if (this.localEmployeeStatus.value === 2) {
            this.record.dismissalReason.value = this.localEmployeeBaseDismissal.label;
            this.record.dismissalDate.value = statusChangeDate;
          } else {
            this.record.dismissalReason.value = "";
            this.record.dismissalDate.value = "";
          }
          this.$notify({
            group: "change-status-employee",
            data: {
              employeeName: this.record.fullName.value,
            },
          });
          this.closeModal();
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.m-change-status {
  position: relative;
  width: 100%;
  transition: 0.2s;

  &-title {
    font: 500 18px Fira Sans;
    line-height: 120%;
  }
  @media (max-width: 700px) {
    &-title {
      font-size: 15px;
    }
  }

  &-fullname {
    font: 400 18px Fira Sans;
    line-height: 120%;
    @media screen and (max-width: 700px) {
      font-size: 15px;
    }
  }

  &-select-choice-status {
    margin-top: 20px;

    &-required {
      padding-bottom: 14px;
    }
  }

  &-select-choice-base {
    margin-top: 24px;

    &-required {
      padding-bottom: 14px;
    }
  }

  &-input-cause {
    margin: 27px 0 30px 0;

    &-required {
      padding-bottom: 14px;
    }
  }

  &-close {
    position: absolute;
    top: 12px;
    right: 10px;
    cursor: pointer;
  }

  &-buttons {
    display: flex;
    margin-top: 29px;
    justify-content: flex-end;

    &::v-deep > .c-button:first-child {
      margin-right: 10px;
    }
    @media (max-width: 700px) {
      &::v-deep > .c-button {
        margin-right: 0 !important;
        border-radius: 0;
        width: 50%;
      }

      &::v-deep > .c-button > .c-button__wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        margin: 0 !important;
        border-radius: 0;
      }
    }
  }
  @media (max-width: 700px) {
    &-buttons {
      margin: 30px -20px 0 -20px;
    }
  }
}

::v-deep .modal-custom-size {
  max-width: 590px !important;
}
::v-deep .modal-body {
  padding: 27px 34px 30px 32px;
}
@media (max-width: 700px) {
  ::v-deep .modal-dialog-centered {
    align-items: flex-start;
  }
  ::v-deep .modal-custom-size {
    max-width: 100% !important;
  }
  ::v-deep .modal-body {
    padding: 28px 20px 0 20px;
  }
}
::v-deep .modal-dialog {
  margin: 0 auto;
}
::v-deep .modal.fade .modal-dialog {
  transform: none;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
